function RestrictedPag({ isLoggedIn, user, Login, Logout }) {
    return(
    <div>
        {(isLoggedIn === true)?
        <div className="logout">
            <h2>Bem-vindo {user}</h2>
            <button onClick={Logout}>Logout</button>
        </div>
        :
        <div className="login">
            <h2>Você não pode acessar essa página</h2>
            <button onClick={Login}>Login</button>
        </div>
        }
    </div>
  );
}

export default RestrictedPag
